import cn from "classnames"
import { MediaRight } from "trunx"

import { Media } from "ui-kit/components-branded/index"
import { Indicators } from "modules/HRAccount/Indicators/Indicators"
import { IndicatorCard } from "modules/HRAccount/IndicatorCard/IndicatorCard"
import { CURRENCY } from "utils/constants"
import { Statistic } from "modules/HRAccount/api"
import { Title } from "modules/HRAccount/Title"
import style from "modules/HRAccount/Aggregates/aggregates.module.scss"
import { formatPrice } from "utils/utils"

export function Aggregates({
    statistics,
    controls,
}: {
    statistics: Statistic
    controls: JSX.Element
}) {
    return (
        <>
            <Media className={cn("mgb-2", style.controls)}>
                <div className="image">
                    <Title dataTestId="statistics">Статистика компании</Title>
                </div>
                <MediaRight>{controls}</MediaRight>
            </Media>
            <Indicators>
                <IndicatorCard
                    title={
                        <IndicatorCard.Title isSecondary className="mb-1">
                            Сотрудники в&nbsp;терапии
                        </IndicatorCard.Title>
                    }
                    value={
                        <IndicatorCard.ValueSmall>{statistics.employees}</IndicatorCard.ValueSmall>
                    }
                    iconProps={{
                        src: "female-office-worker.png",
                        width: 24,
                        height: 24,
                    }}
                />
                <IndicatorCard
                    title={
                        <IndicatorCard.Title isSecondary className="mb-1">
                            Сессий на&nbsp;сотрудника
                        </IndicatorCard.Title>
                    }
                    value={
                        <IndicatorCard.ValueSmall>
                            {statistics.session_per_employee.toLocaleString()}
                        </IndicatorCard.ValueSmall>
                    }
                    iconProps={{
                        src: "abacus-emoji.png",
                        width: 24,
                        height: 24,
                    }}
                />
                <IndicatorCard
                    title={
                        <IndicatorCard.Title isSecondary className="mb-1">
                            Всего сессий
                        </IndicatorCard.Title>
                    }
                    value={
                        <IndicatorCard.ValueSmall>
                            {statistics.session_count}
                        </IndicatorCard.ValueSmall>
                    }
                    iconProps={{
                        src: "bar-chart.png",
                        width: 24,
                        height: 24,
                    }}
                />
                <IndicatorCard
                    title={
                        <IndicatorCard.Title isSecondary className="mb-1">
                            Средний чек компании на&nbsp;1&nbsp;сессию
                        </IndicatorCard.Title>
                    }
                    value={
                        <IndicatorCard.ValueSmall>
                            {statistics
                                ? formatPrice(statistics.average_bill, CURRENCY.RUB)
                                : undefined}
                        </IndicatorCard.ValueSmall>
                    }
                />
                <IndicatorCard
                    title={
                        <IndicatorCard.Title isSecondary className="mb-1">
                            Вложения в&nbsp;ментальное здоровье
                        </IndicatorCard.Title>
                    }
                    value={
                        <IndicatorCard.ValueSmall>
                            {statistics
                                ? formatPrice(statistics.expenses_sum, CURRENCY.RUB)
                                : undefined}
                        </IndicatorCard.ValueSmall>
                    }
                    iconProps={{
                        src: "chart.png",
                        width: 24,
                        height: 24,
                    }}
                />
            </Indicators>
        </>
    )
}
